import React, { useState } from 'react';
import Scroll from './Scroll';

const Header = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const [visibilityClass, setVisibilityClass] = useState("");

  const toggleMenu = value => {
    setOpenMenu(value);
  };
  
  // handleScroll = () => {
  //   if (window.pageYOffset > 300) {
  //     if (visibilityClass !== 'navbar-shrink') {
  //       setVisibilityClass({ visibilityClass: 'navbar-shrink' });
  //     }
  //   } else {
  //     if (visibilityClass === 'navbar-shrink') {
  //       setVisibilityClass({ visibilityClass: '' });
  //     }
  //   }
  // };

  // useEffect(() => {
  //   window.addEventListener('scroll', this.handleScroll);
  // }, [visibilityClass])

  // useEffect(() => {
  //   window.removeEventListener('scroll', this.handleScroll);
  // }, [visibilityClass])

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-light fixed-top ${visibilityClass}`}
      id="mainNav"
    >
      <div className="container">
        <a className="navbar-brand" href="#page-top">
          <span>Project/5mins</span>
        </a>
        <button
          onClick={_ => toggleMenu(!openMenu)}
          className={`navbar-toggler navbar-toggler-right ${
            openMenu ? '' : 'collapsed'
            }`}
          type="button"
          aria-controls="navbarResponsive"
          aria-expanded={openMenu}
          aria-label="Toggle navigation"
        >
          <i className="fas fa-bars"></i>
        </button>

        <div
          className={`collapse navbar-collapse ${openMenu ? 'show' : ''}`}
          id="navbarResponsive"
        >
          {/* <ul className="navbar-nav ml-auto"> */}
          <ul className="navbar-nav">
            <li className="nav-item">
              <Scroll
                onClick={_ => toggleMenu(!openMenu)}
                type="id"
                element="download"
              >
                <a className="nav-link" href="#download">
                  Download
                  </a>
              </Scroll>
            </li>
            <li className="nav-item">
              <Scroll
                onClick={_ => toggleMenu(!openMenu)}
                type="id"
                element="features"
              >
                <a className="nav-link" href="#features">
                  Features
                  </a>
              </Scroll>
            </li>
            <li className="nav-item">
              <Scroll
                onClick={_ => toggleMenu(!openMenu)}
                type="id"
                element="contact"
              >
                <a className="nav-link" href="#contact">
                  Contact
                  </a>
              </Scroll>
            </li>
          </ul>
        </div>
      </div>
      <div className="download-app ml-auto">
        <span className="mr-2">DOWNLOAD THE APP</span>
        <a href="#" className="mr-2"><i className="fab fa-android"></i></a>
        <a href="#"><i className="fab fa-apple"></i></a>
      </div>
    </nav>
  );
}

export default Header;